{
  "customer-form-dialog": {
    "field": {
      "last_checkin": "Dernier check-in",
      "number_of_visit": "Nombre de visites",
      "registered_since": "Enregistré depuis",
      "type": "Type"
    },
    "button": {
      "cancel": "Annuler",
      "submit": "Déposer"
    },
    "text": {
      "create_customer": "Créer un nouveau profil client",
      "create_customer_success": "Créé avec succès",
      "edit_customer": "Modifier le profil du client",
      "edit_customer_success": "Mise à jour réussie"
    }
  }
}
